module.exports = __webpack_public_path__ + "static/media/Notch_Before.153b3574.jpg";